module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAADNSURBVFiF7ZcxDoMwDEVNlDtFDJW6cQEOwcbKEVi7cYhegIWOqKdKtyqKEjnISRvEf1NEyPeXHRlDBAAA16bhXujm3frP1qllz+XS0inCy2C+62F5HzYm0VKiaD8gmMFQKUrhxgqVO5rBsTc09ia2nQ0uTvUlhkEpMCileoO6m/cXEd2PHCrVJ33dhuymKPFz9w8sKa3Xqb35G1yGcg4LnG71dxAGpcCglOoNRnvg4ykb7VPh4gQNuv2o9HTN9dTzlthF+idXSgsAAK7AB0/fOfHR5m0bAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons8-dumbbell-40.png
// module id = 236
// module chunks = 0